import { lazy } from 'react';

// Lazy-load pages for better performance with better chunk names
export const Home = lazy(() => import(/* webpackChunkName: "home" */ '../pages/Home'));
export const About = lazy(() => import(/* webpackChunkName: "about" */ '../pages/About'));
export const Contact = lazy(() => import(/* webpackChunkName: "contact" */ '../pages/Contact'));
export const Privacy = lazy(() => import(/* webpackChunkName: "privacy" */ '../pages/Privacy'));
export const Impressum = lazy(() => import(/* webpackChunkName: "impressum" */ '../pages/Impressum'));
export const UeberSeidelsImmobilien = lazy(() => import(/* webpackChunkName: "offer" */ '../pages/UeberSeidelsImmobilien'));

// Lazy-load map components (only load when needed)
export const CookieAwareMap = lazy(() => import(/* webpackChunkName: "maps" */ '../components/ui/CookieAwareMap'));
export const PropertyMap = lazy(() => import(/* webpackChunkName: "maps" */ '../components/ui/PropertyMap'));
export const Map = lazy(() => import(/* webpackChunkName: "maps" */ '../components/ui/Map'));

// Lazy-load framer-motion to reduce initial bundle
export const MotionDiv = lazy(() => import('framer-motion').then(module => ({ default: module.motion.div })));
export const AnimatePresence = lazy(() => import('framer-motion').then(module => ({ default: module.AnimatePresence })));
